import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const fieldClass = 'w-full rounded-lg border border-white/15 bg-charcoal-800 px-3.5 py-2.5 text-[13.5px] text-cream placeholder:text-charcoal-400 transition-colors duration-150 ease-smooth focus:border-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400/25';
export function DemoCta() {
  const reduceMotion = useReducedMotion();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'sent'>('idle');
  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!name.trim() || !email.includes('@') || !organisation.trim()) {
      setStatus('error');
      return;
    }
    setStatus('sent');
  };
  return <section id="demo" className="bg-charcoal-700" data-id="element-78" data-mp="2cb7pmwmvdzyz">
      <div className="mx-auto grid max-w-[1180px] gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-16 lg:py-24" data-id="element-79" data-mp="2cciqoooxktme">
        <div data-id="element-80" data-mp="16axkje6mlm9s">
          <p className="micro-label text-[9px] text-gold-400" data-id="element-81" data-mp="16ao3wh7h0rgr">Book a demonstration</p>
          <h2 className="mt-4 max-w-[22ch] font-display text-[32px] font-semibold leading-[1.08] tracking-[-0.03em] text-cream sm:text-[38px]" data-id="element-82" data-mp="sb6afoj8cq12">
            See KeyTurn on a project like yours.
          </h2>
          <p className="mt-5 max-w-[52ch] text-[15px] leading-relaxed text-charcoal-200" data-id="element-83" data-mp="1kz24smlbu5uo">
            Forty-five minutes, walked through with one of your own projects in mind - an opening,
            takeover, rebrand or group rollout. We will show Health, My Turn, the meeting loop and a
            workbook round trip end to end.
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-charcoal-800 p-6 sm:p-7" data-id="element-84" data-mp="1g692049f57l8">
          {status === 'sent' ? <div role="status" className="flex flex-col items-start gap-4 py-6" data-id="element-85" data-mp="28pemgp6djgyg">
              <motion.span className="flex h-10 w-10 items-center justify-center rounded-full bg-sage" initial={reduceMotion ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-86" data-mp="2ikv91l037qmx">
                <CheckIcon size={19} strokeWidth={2.4} className="text-charcoal-800" aria-hidden="true" data-id="element-87" data-mp="24k2e4z5vitja" />
              </motion.span>
              <div data-id="element-88" data-mp="1utpx3gx9pihw">
                <p className="font-display text-[19px] font-medium tracking-[-0.02em] text-cream" data-id="element-89" data-mp="1ut7r3skszpws">
                  Request received
                </p>
                <p className="mt-2 text-[13.5px] leading-relaxed text-charcoal-200" data-id="element-90" data-mp="1ky61ywqj2nu7">
                  We will come back to you within one working day to find a time.
                </p>
              </div>
            </div> : <form onSubmit={submit} noValidate className="space-y-4" data-id="element-91" data-mp="1byjbh5zc72fx">
              <div data-id="element-92" data-mp="3nj09bgfwdl7k">
                <label htmlFor="demo-name" className="micro-label mb-1.5 block text-[8.5px] text-charcoal-300" data-id="element-93" data-mp="3njigv980flus">
                  Full name
                </label>
                <input id="demo-name" type="text" value={name} onChange={event => setName(event.target.value)} placeholder="Sophia Ellery" className={fieldClass} data-id="element-94" data-mp="d9ct8xsiqce" />
              </div>

              <div data-id="element-95" data-mp="3dtyxm2gdxpze">
                <label htmlFor="demo-email" className="micro-label mb-1.5 block text-[8.5px] text-charcoal-300" data-id="element-96" data-mp="3dtgq29o9vpc6">
                  Work email
                </label>
                <input id="demo-email" type="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="you@hotelgroup.com" className={fieldClass} data-id="element-97" data-mp="2l49vtmvuplwq" />
              </div>

              <div data-id="element-98" data-mp="ro5himobv89g">
                <label htmlFor="demo-org" className="micro-label mb-1.5 block text-[8.5px] text-charcoal-300" data-id="element-99" data-mp="rkhorpqpipvs">
                  Hotel group
                </label>
                <input id="demo-org" type="text" value={organisation} onChange={event => setOrganisation(event.target.value)} placeholder="Marchmont Collection" className={fieldClass} data-id="element-100" data-mp="1fc6inaj6fmeu" />
              </div>

              <p role="alert" className={`min-h-[20px] text-[12px] ${status === 'error' ? 'text-clay-300' : 'text-transparent'}`} data-id="element-101" data-mp="1kcb299fdsx9a">
                {status === 'error' ? 'Add your name, a valid work email and your hotel group.' : 'placeholder'}
              </p>

              <button type="submit" className="w-full rounded-lg bg-gold-400 px-4 py-3 text-[13.5px] font-semibold text-charcoal-800 transition-[background-color,transform] duration-150 ease-smooth hover:bg-gold-300 active:scale-[0.99]" data-id="element-102" data-mp="3g0szid5gle5e">
                Request a demonstration
              </button>
            </form>}
        </div>
      </div>
    </section>;
}